// @ts-check

import { Image as BaseImage } from '@react-pdf/renderer';
import React from 'react';
import { Box, Flex, Text } from '../../pdf-design-system';

export default function RoussillonCatalogProfilePage({ bleed = 3, baseUrl }) {
  return (
    <Flex
      style={{
        position: 'absolute',
        // backgroundColor: theme.colors.accent,
        paddingHorizontal: `${15 + bleed * 2}mm`,
        bottom: 0,
        left: 0,
        right: 0,
        height: `${20 + bleed}mm`,
        paddingBottom: `${bleed}mm`,
        alignItems: 'center',
      }}
    >
      <BaseImage
        src="https://res.cloudinary.com/bottlebooks/image/upload/v1652016635/pdf-objects/Roussillon/roussillonLogo_small.jpg"
        style={{ marginRight: 3, height: '15mm' }}
      />
      <Box>
        <Text variant="light">View our online tasting catalogue at </Text>
        <Text variant="light">{baseUrl}</Text>
      </Box>
    </Flex>
  );
}
